/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
import type { AdjustmentToleranceLevel } from './AdjustmentToleranceLevel';
import {
    AdjustmentToleranceLevelFromJSON,
    AdjustmentToleranceLevelFromJSONTyped,
    AdjustmentToleranceLevelToJSON,
} from './AdjustmentToleranceLevel';
import type { AgeGroup } from './AgeGroup';
import { AgeGroupFromJSON, AgeGroupFromJSONTyped, AgeGroupToJSON } from './AgeGroup';
import type { BudgetConstraintType } from './BudgetConstraintType';
import {
    BudgetConstraintTypeFromJSON,
    BudgetConstraintTypeFromJSONTyped,
    BudgetConstraintTypeToJSON,
} from './BudgetConstraintType';
import type { CampaignBasicInfoResponseDto } from './CampaignBasicInfoResponseDto';
import {
    CampaignBasicInfoResponseDtoFromJSON,
    CampaignBasicInfoResponseDtoFromJSONTyped,
    CampaignBasicInfoResponseDtoToJSON,
} from './CampaignBasicInfoResponseDto';
import type { ComparisonMeta } from './ComparisonMeta';
import {
    ComparisonMetaFromJSON,
    ComparisonMetaFromJSONTyped,
    ComparisonMetaToJSON,
} from './ComparisonMeta';
import type { CountryCodeIso2 } from './CountryCodeIso2';
import {
    CountryCodeIso2FromJSON,
    CountryCodeIso2FromJSONTyped,
    CountryCodeIso2ToJSON,
} from './CountryCodeIso2';
import type { DecimalComparisonValue } from './DecimalComparisonValue';
import {
    DecimalComparisonValueFromJSON,
    DecimalComparisonValueFromJSONTyped,
    DecimalComparisonValueToJSON,
} from './DecimalComparisonValue';
import type { Gender } from './Gender';
import { GenderFromJSON, GenderFromJSONTyped, GenderToJSON } from './Gender';
import type { OptimisationStrategy } from './OptimisationStrategy';
import {
    OptimisationStrategyFromJSON,
    OptimisationStrategyFromJSONTyped,
    OptimisationStrategyToJSON,
} from './OptimisationStrategy';
import type { ScenarioAdFormatResponseDto } from './ScenarioAdFormatResponseDto';
import {
    ScenarioAdFormatResponseDtoFromJSON,
    ScenarioAdFormatResponseDtoFromJSONTyped,
    ScenarioAdFormatResponseDtoToJSON,
} from './ScenarioAdFormatResponseDto';
import type { ScenarioLevelResultComparisonResponseDto } from './ScenarioLevelResultComparisonResponseDto';
import {
    ScenarioLevelResultComparisonResponseDtoFromJSON,
    ScenarioLevelResultComparisonResponseDtoFromJSONTyped,
    ScenarioLevelResultComparisonResponseDtoToJSON,
} from './ScenarioLevelResultComparisonResponseDto';
import type { ScenarioMinSpendPerChannelResponseDto } from './ScenarioMinSpendPerChannelResponseDto';
import {
    ScenarioMinSpendPerChannelResponseDtoFromJSON,
    ScenarioMinSpendPerChannelResponseDtoFromJSONTyped,
    ScenarioMinSpendPerChannelResponseDtoToJSON,
} from './ScenarioMinSpendPerChannelResponseDto';
import type { ScenarioStatus } from './ScenarioStatus';
import {
    ScenarioStatusFromJSON,
    ScenarioStatusFromJSONTyped,
    ScenarioStatusToJSON,
} from './ScenarioStatus';

/**
 *
 * @export
 * @interface ScenarioWithComparisonResponseDto
 */
export interface ScenarioWithComparisonResponseDto {
    /**
     *
     * @type {DecimalComparisonValue}
     * @memberof ScenarioWithComparisonResponseDto
     */
    budget?: DecimalComparisonValue;
    /**
     *
     * @type {ComparisonMeta}
     * @memberof ScenarioWithComparisonResponseDto
     */
    comparedWith?: ComparisonMeta;
    /**
     *
     * @type {CampaignBasicInfoResponseDto}
     * @memberof ScenarioWithComparisonResponseDto
     */
    campaignBasicInfo?: CampaignBasicInfoResponseDto;
    /**
     *
     * @type {Array<ScenarioLevelResultComparisonResponseDto>}
     * @memberof ScenarioWithComparisonResponseDto
     */
    scenarioLevelResults?: Array<ScenarioLevelResultComparisonResponseDto> | null;
    /**
     *
     * @type {string}
     * @memberof ScenarioWithComparisonResponseDto
     */
    campaignId?: string;
    /**
     *
     * @type {OptimisationStrategy}
     * @memberof ScenarioWithComparisonResponseDto
     */
    optimisationStrategy?: OptimisationStrategy;
    /**
     *
     * @type {string}
     * @memberof ScenarioWithComparisonResponseDto
     */
    scenarioName?: string | null;
    /**
     *
     * @type {ScenarioStatus}
     * @memberof ScenarioWithComparisonResponseDto
     */
    scenarioStatus?: ScenarioStatus;
    /**
     *
     * @type {Array<CountryCodeIso2>}
     * @memberof ScenarioWithComparisonResponseDto
     */
    countries?: Array<CountryCodeIso2> | null;
    /**
     *
     * @type {Array<Gender>}
     * @memberof ScenarioWithComparisonResponseDto
     */
    genders?: Array<Gender> | null;
    /**
     *
     * @type {Array<AgeGroup>}
     * @memberof ScenarioWithComparisonResponseDto
     */
    ageGroups?: Array<AgeGroup> | null;
    /**
     *
     * @type {Date}
     * @memberof ScenarioWithComparisonResponseDto
     */
    startDate?: Date | null;
    /**
     *
     * @type {Date}
     * @memberof ScenarioWithComparisonResponseDto
     */
    endDate?: Date | null;
    /**
     *
     * @type {BudgetConstraintType}
     * @memberof ScenarioWithComparisonResponseDto
     */
    budgetConstraintType?: BudgetConstraintType;
    /**
     *
     * @type {AdjustmentToleranceLevel}
     * @memberof ScenarioWithComparisonResponseDto
     */
    adjustmentToleranceLevel?: AdjustmentToleranceLevel;
    /**
     *
     * @type {Array<ScenarioAdFormatResponseDto>}
     * @memberof ScenarioWithComparisonResponseDto
     */
    adFormats?: Array<ScenarioAdFormatResponseDto> | null;
    /**
     *
     * @type {Array<ScenarioMinSpendPerChannelResponseDto>}
     * @memberof ScenarioWithComparisonResponseDto
     */
    minSpendPerChannels?: Array<ScenarioMinSpendPerChannelResponseDto> | null;
    /**
     *
     * @type {boolean}
     * @memberof ScenarioWithComparisonResponseDto
     */
    isUsingGlobalCountry?: boolean | null;
    /**
     *
     * @type {boolean}
     * @memberof ScenarioWithComparisonResponseDto
     */
    isAccessibleToEveryone?: boolean | null;
    /**
     *
     * @type {string}
     * @memberof ScenarioWithComparisonResponseDto
     */
    id?: string;
    /**
     *
     * @type {Date}
     * @memberof ScenarioWithComparisonResponseDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof ScenarioWithComparisonResponseDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the ScenarioWithComparisonResponseDto interface.
 */
export function instanceOfScenarioWithComparisonResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScenarioWithComparisonResponseDtoFromJSON(
    json: any,
): ScenarioWithComparisonResponseDto {
    return ScenarioWithComparisonResponseDtoFromJSONTyped(json, false);
}

export function ScenarioWithComparisonResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ScenarioWithComparisonResponseDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        budget: !exists(json, 'budget')
            ? undefined
            : DecimalComparisonValueFromJSON(json['budget']),
        comparedWith: !exists(json, 'compared_with')
            ? undefined
            : ComparisonMetaFromJSON(json['compared_with']),
        campaignBasicInfo: !exists(json, 'campaign_basic_info')
            ? undefined
            : CampaignBasicInfoResponseDtoFromJSON(json['campaign_basic_info']),
        scenarioLevelResults: !exists(json, 'scenario_level_results')
            ? undefined
            : json['scenario_level_results'] === null
            ? null
            : (json['scenario_level_results'] as Array<any>).map(
                  ScenarioLevelResultComparisonResponseDtoFromJSON,
              ),
        campaignId: !exists(json, 'campaign_id') ? undefined : json['campaign_id'],
        optimisationStrategy: !exists(json, 'optimisation_strategy')
            ? undefined
            : OptimisationStrategyFromJSON(json['optimisation_strategy']),
        scenarioName: !exists(json, 'scenario_name') ? undefined : json['scenario_name'],
        scenarioStatus: !exists(json, 'scenario_status')
            ? undefined
            : ScenarioStatusFromJSON(json['scenario_status']),
        countries: !exists(json, 'countries')
            ? undefined
            : json['countries'] === null
            ? null
            : (json['countries'] as Array<any>).map(CountryCodeIso2FromJSON),
        genders: !exists(json, 'genders')
            ? undefined
            : json['genders'] === null
            ? null
            : (json['genders'] as Array<any>).map(GenderFromJSON),
        ageGroups: !exists(json, 'age_groups')
            ? undefined
            : json['age_groups'] === null
            ? null
            : (json['age_groups'] as Array<any>).map(AgeGroupFromJSON),
        startDate: !exists(json, 'start_date')
            ? undefined
            : json['start_date'] === null
            ? null
            : new Date(json['start_date']),
        endDate: !exists(json, 'end_date')
            ? undefined
            : json['end_date'] === null
            ? null
            : new Date(json['end_date']),
        budgetConstraintType: !exists(json, 'budget_constraint_type')
            ? undefined
            : BudgetConstraintTypeFromJSON(json['budget_constraint_type']),
        adjustmentToleranceLevel: !exists(json, 'adjustment_tolerance_level')
            ? undefined
            : AdjustmentToleranceLevelFromJSON(json['adjustment_tolerance_level']),
        adFormats: !exists(json, 'ad_formats')
            ? undefined
            : json['ad_formats'] === null
            ? null
            : (json['ad_formats'] as Array<any>).map(ScenarioAdFormatResponseDtoFromJSON),
        minSpendPerChannels: !exists(json, 'min_spend_per_channels')
            ? undefined
            : json['min_spend_per_channels'] === null
            ? null
            : (json['min_spend_per_channels'] as Array<any>).map(
                  ScenarioMinSpendPerChannelResponseDtoFromJSON,
              ),
        isUsingGlobalCountry: !exists(json, 'is_using_global_country')
            ? undefined
            : json['is_using_global_country'],
        isAccessibleToEveryone: !exists(json, 'is_accessible_to_everyone')
            ? undefined
            : json['is_accessible_to_everyone'],
        id: !exists(json, 'id') ? undefined : json['id'],
        createdAt: !exists(json, 'created_at') ? undefined : new Date(json['created_at']),
        updatedAt: !exists(json, 'updated_at') ? undefined : new Date(json['updated_at']),
    };
}

export function ScenarioWithComparisonResponseDtoToJSON(
    value?: ScenarioWithComparisonResponseDto | null,
): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        budget: DecimalComparisonValueToJSON(value.budget),
        compared_with: ComparisonMetaToJSON(value.comparedWith),
        campaign_basic_info: CampaignBasicInfoResponseDtoToJSON(value.campaignBasicInfo),
        scenario_level_results:
            value.scenarioLevelResults === undefined
                ? undefined
                : value.scenarioLevelResults === null
                ? null
                : (value.scenarioLevelResults as Array<any>).map(
                      ScenarioLevelResultComparisonResponseDtoToJSON,
                  ),
        campaign_id: value.campaignId,
        optimisation_strategy: OptimisationStrategyToJSON(value.optimisationStrategy),
        scenario_name: value.scenarioName,
        scenario_status: ScenarioStatusToJSON(value.scenarioStatus),
        countries:
            value.countries === undefined
                ? undefined
                : value.countries === null
                ? null
                : (value.countries as Array<any>).map(CountryCodeIso2ToJSON),
        genders:
            value.genders === undefined
                ? undefined
                : value.genders === null
                ? null
                : (value.genders as Array<any>).map(GenderToJSON),
        age_groups:
            value.ageGroups === undefined
                ? undefined
                : value.ageGroups === null
                ? null
                : (value.ageGroups as Array<any>).map(AgeGroupToJSON),
        start_date:
            value.startDate === undefined
                ? undefined
                : value.startDate === null
                ? null
                : value.startDate.toISOString(),
        end_date:
            value.endDate === undefined
                ? undefined
                : value.endDate === null
                ? null
                : value.endDate.toISOString(),
        budget_constraint_type: BudgetConstraintTypeToJSON(value.budgetConstraintType),
        adjustment_tolerance_level: AdjustmentToleranceLevelToJSON(value.adjustmentToleranceLevel),
        ad_formats:
            value.adFormats === undefined
                ? undefined
                : value.adFormats === null
                ? null
                : (value.adFormats as Array<any>).map(ScenarioAdFormatResponseDtoToJSON),
        min_spend_per_channels:
            value.minSpendPerChannels === undefined
                ? undefined
                : value.minSpendPerChannels === null
                ? null
                : (value.minSpendPerChannels as Array<any>).map(
                      ScenarioMinSpendPerChannelResponseDtoToJSON,
                  ),
        is_using_global_country: value.isUsingGlobalCountry,
        is_accessible_to_everyone: value.isAccessibleToEveryone,
        id: value.id,
        created_at: value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
        updated_at: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    };
}
